import clsxm from '@/lib/clsxm';

import COMMON_CLASS_NAMES from '@/constants/common-class-names';
import { BackgroundWidth } from '@/enums/background-width';
import { LightColor } from '@/enums/light-color';

export const backgroundMap: Record<
  LightColor,
  { main: string; light?: string; svg: string }
> = {
  [LightColor.CORAL]: {
    main: 'bg-coral',
    svg: 'fill-coral',
  },
  [LightColor.LIGHT_PINK]: {
    main: 'bg-primary-light',
    svg: 'fill-primary-light',
  },
  [LightColor.LIGHT_BLUE]: {
    main: 'bg-light-blue',
    svg: 'fill-light-blue',
  },
  [LightColor.LIGHT_PURPLE]: {
    main: 'bg-light-purple',
    svg: 'fill-light-purple',
  },
  [LightColor.ORCHID]: {
    main: 'bg-orchid',
    svg: 'fill-orchid',
  },
  [LightColor.SKY]: {
    main: 'bg-sky',
    svg: 'fill-sky',
  },
  [LightColor.WHITE]: {
    main: 'bg-white',
    svg: 'fill-white',
  },
};

type BackgroundProps = {
  backgroundColor?: LightColor;
  backgroundWidth?: BackgroundWidth;
};
export const Background = (props: BackgroundProps) => {
  const { backgroundColor, backgroundWidth = BackgroundWidth.PAGE_WIDE } =
    props;
  const colors = backgroundColor && backgroundMap[backgroundColor];

  return (
    <div
      className={clsxm(
        'z-1 absolute left-1/2 top-0 h-full w-full -translate-x-1/2 empty:hidden',
        backgroundWidth === BackgroundWidth.PAGE_WIDE
          ? ' w-full'
          : COMMON_CLASS_NAMES.mainContentContainerWidth
      )}
    >
      <div className={clsxm('z-1 absolute h-full w-full', colors?.main)} />
    </div>
  );
};
